import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { MessageSquare, LayoutTemplate, Send, CreditCard, LogOut, Settings, HelpCircle, Bot, BookOpen, BrainCircuit, BarChart3 } from 'lucide-react';
import { useChatContext } from '../../context/ChatContext';
import { getSubscriptionAccessState } from '../../utils/subscriptionAccess';

export default function PrimarySidebar() {
  const navigate = useNavigate();
  const { clientProfile } = useChatContext();
  const accessState = getSubscriptionAccessState(clientProfile);
  const permissions = clientProfile?.permissions || {};
  const canUsePlanFeatures = accessState.canAccessPaidFeatures;
  const canUseBot = !!permissions.traditional_bot_enabled;
  const canUseKnowledge = !!permissions.knowledge_base_enabled;
  const canUseAISettings = !!permissions.ai_agent_enabled;
  const canUseAnalytics = !!permissions.analytics_enabled;

  const logout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('role');
    navigate('/login');
  };

  const navClass = ({ isActive }) => `nav-item ${isActive ? 'active' : ''}`;

  return (
    <div className="primary-sidebar glossy" role="navigation" aria-label="Primary">
      <div className="sidebar-brand" title="Blastmate">
        <img src="/logo.png" alt="Blastmate" />
        <span className="sidebar-brand-name">Blastmate</span>
      </div>
      <nav className="sidebar-nav">
        <NavLink to="/main" end className={navClass} title="Conversations" aria-label="Conversations">
          <span className="active-indicator" aria-hidden="true" />
          <MessageSquare size={18} />
          <span className="nav-label">Chats</span>
        </NavLink>
        {canUsePlanFeatures && (
        <NavLink to="/templates" className={navClass} title="Templates" aria-label="Templates">
          <span className="active-indicator" aria-hidden="true" />
          <LayoutTemplate size={18} />
          <span className="nav-label">Templates</span>
        </NavLink>
        )}
        {canUsePlanFeatures && (
        <NavLink to="/campaigns" className={navClass} title="Campaigns" aria-label="Campaigns">
          <span className="active-indicator" aria-hidden="true" />
          <Send size={18} />
          <span className="nav-label">Campaigns</span>
        </NavLink>
        )}
        {canUsePlanFeatures && canUseBot && (
        <NavLink to="/bot" className={navClass} title="Bot Builder" aria-label="Bot Builder">
          <span className="active-indicator" aria-hidden="true" />
          <Bot size={18} />
          <span className="nav-label">Bot</span>
        </NavLink>
        )}
        {canUsePlanFeatures && canUseKnowledge && (
        <NavLink to="/knowledge" className={navClass} title="Knowledge Base" aria-label="Knowledge Base">
          <span className="active-indicator" aria-hidden="true" />
          <BookOpen size={18} />
          <span className="nav-label">Knowledge</span>
        </NavLink>
        )}
        {canUsePlanFeatures && canUseAISettings && (
        <NavLink to="/ai-settings" className={navClass} title="AI Settings & Safety" aria-label="AI Settings">
          <span className="active-indicator" aria-hidden="true" />
          <BrainCircuit size={18} />
          <span className="nav-label">AI Settings</span>
        </NavLink>
        )}
        {canUsePlanFeatures && canUseAnalytics && (
        <NavLink to="/analytics" className={navClass} title="Analytics" aria-label="Analytics">
          <span className="active-indicator" aria-hidden="true" />
          <BarChart3 size={18} />
          <span className="nav-label">Analytics</span>
        </NavLink>
        )}
        <NavLink to="/billing" className={navClass} title="Billing" aria-label="Billing">
          <span className="active-indicator" aria-hidden="true" />
          <CreditCard size={18} />
          <span className="nav-label">Billing</span>
        </NavLink>
        <NavLink to="/help" className={navClass} title="Help & Support" aria-label="Help & Support">
          <span className="active-indicator" aria-hidden="true" />
          <HelpCircle size={18} />
          <span className="nav-label">Help</span>
        </NavLink>
      </nav>
      <div className="sidebar-footer">
        <NavLink to="/settings" className={navClass} title="Settings" aria-label="Settings">
          <span className="active-indicator" aria-hidden="true" />
          <Settings size={18} />
          <span className="nav-label">Settings</span>
        </NavLink>
        <button onClick={logout} className="nav-item" title="Logout" aria-label="Logout">
          <span className="active-indicator" aria-hidden="true" />
          <LogOut size={18} />
          <span className="nav-label">Logout</span>
        </button>
      </div>
    </div>
  );
}
